var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import { BASE_PATH, BaseAPI } from './base';
export var Award;
(function (Award) {
    Award["Gold"] = "GOLD";
    Award["Silver"] = "SILVER";
    Award["Bronze"] = "BRONZE";
    Award["None"] = "NONE";
})(Award || (Award = {}));
export var CorrectAnswerRateType;
(function (CorrectAnswerRateType) {
    CorrectAnswerRateType["Basic"] = "BASIC";
    CorrectAnswerRateType["LevelupDrill"] = "LEVELUP_DRILL";
})(CorrectAnswerRateType || (CorrectAnswerRateType = {}));
export var DrillType;
(function (DrillType) {
    DrillType["Kokugo"] = "KOKUGO";
    DrillType["Sansu"] = "SANSU";
    DrillType["Rika"] = "RIKA";
    DrillType["Shakai"] = "SHAKAI";
    DrillType["Kanji"] = "KANJI";
    DrillType["Endrill"] = "ENDRILL";
    DrillType["Enwork"] = "ENWORK";
    DrillType["Kana"] = "KANA";
    DrillType["ChugakuKokugo"] = "CHUGAKU_KOKUGO";
    DrillType["ChugakuSugaku"] = "CHUGAKU_SUGAKU";
    DrillType["ChugakuEndrill"] = "CHUGAKU_ENDRILL";
    DrillType["ChugakuRika"] = "CHUGAKU_RIKA";
    DrillType["ChugakuChiri"] = "CHUGAKU_CHIRI";
    DrillType["ChugakuRekishi"] = "CHUGAKU_REKISHI";
    DrillType["ChugakuKoumin"] = "CHUGAKU_KOUMIN";
    DrillType["ChugakuGijutsu"] = "CHUGAKU_GIJUTSU";
    DrillType["ChugakuKatei"] = "CHUGAKU_KATEI";
    DrillType["ChugakuHotai"] = "CHUGAKU_HOTAI";
    DrillType["ChugakuOngaku"] = "CHUGAKU_ONGAKU";
    DrillType["ChugakuBijutsu"] = "CHUGAKU_BIJUTSU";
    DrillType["ChugakuReviewKokugo"] = "CHUGAKU_REVIEW_KOKUGO";
    DrillType["ChugakuReviewSansu"] = "CHUGAKU_REVIEW_SANSU";
})(DrillType || (DrillType = {}));
export var FileSort;
(function (FileSort) {
    FileSort["CreateDatetime"] = "CREATE_DATETIME";
    FileSort["UpdateDatetime"] = "UPDATE_DATETIME";
    FileSort["Name"] = "NAME";
})(FileSort || (FileSort = {}));
export var Order;
(function (Order) {
    Order["Asc"] = "ASC";
    Order["Desc"] = "DESC";
})(Order || (Order = {}));
export var Phase;
(function (Phase) {
    Phase["FirstTimeStart"] = "FIRST_TIME_START";
    Phase["FirstTimeToLastCompleted"] = "FIRST_TIME_TO_LAST_COMPLETED";
    Phase["FirstTimeWithClose"] = "FIRST_TIME_WITH_CLOSE";
    Phase["MistakeStart"] = "MISTAKE_START";
    Phase["MistakeToLastCompletes"] = "MISTAKE_TO_LAST_COMPLETES";
    Phase["MistakeWithClose"] = "MISTAKE_WITH_CLOSE";
})(Phase || (Phase = {}));
export var ResponseType;
(function (ResponseType) {
    ResponseType["ForTeacher"] = "ForTeacher";
    ResponseType["ForStudent"] = "ForStudent";
})(ResponseType || (ResponseType = {}));
export var WorkType;
(function (WorkType) {
    WorkType["Personal"] = "PERSONAL";
    WorkType["Original"] = "ORIGINAL";
    WorkType["Assignment"] = "ASSIGNMENT";
})(WorkType || (WorkType = {}));
export const AssignmentWorkControllerApiAxiosParamCreator = function (configuration) {
    return {
        createMyAssignmentWork: (originWorkId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('createMyAssignmentWork', 'originWorkId', originWorkId);
            const localVarPath = `/drillweb/work/assignment`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (originWorkId !== undefined) {
                localVarQueryParameter['originWorkId'] = originWorkId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getAssignmentWorks: (assignmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getAssignmentWorks', 'assignmentId', assignmentId);
            const localVarPath = `/drillweb/work/assignment/{assignmentId}`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getWorkEffortByOriginWorkId: (originWorkId, userIds, onlyFirst, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getWorkEffortByOriginWorkId', 'originWorkId', originWorkId);
            assertParamExists('getWorkEffortByOriginWorkId', 'userIds', userIds);
            assertParamExists('getWorkEffortByOriginWorkId', 'onlyFirst', onlyFirst);
            const localVarPath = `/drillweb/work/assignment/effort`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (originWorkId !== undefined) {
                localVarQueryParameter['originWorkId'] = originWorkId;
            }
            if (userIds) {
                localVarQueryParameter['userIds'] = userIds;
            }
            if (onlyFirst !== undefined) {
                localVarQueryParameter['onlyFirst'] = onlyFirst;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const AssignmentWorkControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AssignmentWorkControllerApiAxiosParamCreator(configuration);
    return {
        createMyAssignmentWork(originWorkId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createMyAssignmentWork(originWorkId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getAssignmentWorks(assignmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAssignmentWorks(assignmentId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getWorkEffortByOriginWorkId(originWorkId, userIds, onlyFirst, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkEffortByOriginWorkId(originWorkId, userIds, onlyFirst, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const AssignmentWorkControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AssignmentWorkControllerApiFp(configuration);
    return {
        createMyAssignmentWork(originWorkId, options) {
            return localVarFp.createMyAssignmentWork(originWorkId, options).then((request) => request(axios, basePath));
        },
        getAssignmentWorks(assignmentId, options) {
            return localVarFp.getAssignmentWorks(assignmentId, options).then((request) => request(axios, basePath));
        },
        getWorkEffortByOriginWorkId(originWorkId, userIds, onlyFirst, options) {
            return localVarFp.getWorkEffortByOriginWorkId(originWorkId, userIds, onlyFirst, options).then((request) => request(axios, basePath));
        },
    };
};
export class AssignmentWorkControllerApi extends BaseAPI {
    createMyAssignmentWork(originWorkId, options) {
        return AssignmentWorkControllerApiFp(this.configuration).createMyAssignmentWork(originWorkId, options).then((request) => request(this.axios, this.basePath));
    }
    getAssignmentWorks(assignmentId, options) {
        return AssignmentWorkControllerApiFp(this.configuration).getAssignmentWorks(assignmentId, options).then((request) => request(this.axios, this.basePath));
    }
    getWorkEffortByOriginWorkId(originWorkId, userIds, onlyFirst, options) {
        return AssignmentWorkControllerApiFp(this.configuration).getWorkEffortByOriginWorkId(originWorkId, userIds, onlyFirst, options).then((request) => request(this.axios, this.basePath));
    }
}
export const DrillHistoryControllerApiAxiosParamCreator = function (configuration) {
    return {
        getDrillHistory: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getDrillHistory', 'ids', ids);
            const localVarPath = `/drillweb/history/drillHistory/{ids}`
                .replace(`{${"ids"}}`, encodeURIComponent(String(ids)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const DrillHistoryControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = DrillHistoryControllerApiAxiosParamCreator(configuration);
    return {
        getDrillHistory(ids, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDrillHistory(ids, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const DrillHistoryControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DrillHistoryControllerApiFp(configuration);
    return {
        getDrillHistory(ids, options) {
            return localVarFp.getDrillHistory(ids, options).then((request) => request(axios, basePath));
        },
    };
};
export class DrillHistoryControllerApi extends BaseAPI {
    getDrillHistory(ids, options) {
        return DrillHistoryControllerApiFp(this.configuration).getDrillHistory(ids, options).then((request) => request(this.axios, this.basePath));
    }
}
export const LearningHistoryControllerApiAxiosParamCreator = function (configuration) {
    return {
        getAllUnitCorrectAnswerRates: (drillType, courseId, organizationId, correctAnswerRateType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getAllUnitCorrectAnswerRates', 'drillType', drillType);
            assertParamExists('getAllUnitCorrectAnswerRates', 'courseId', courseId);
            assertParamExists('getAllUnitCorrectAnswerRates', 'organizationId', organizationId);
            assertParamExists('getAllUnitCorrectAnswerRates', 'correctAnswerRateType', correctAnswerRateType);
            const localVarPath = `/drillweb/learning-history/correct-answer-rate/courses/{courseId}/units`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (correctAnswerRateType !== undefined) {
                localVarQueryParameter['correctAnswerRateType'] = correctAnswerRateType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getAllUnitsGradeCorrectAnswerRates: (drillType, courseId, grade, correctAnswerRateType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getAllUnitsGradeCorrectAnswerRates', 'drillType', drillType);
            assertParamExists('getAllUnitsGradeCorrectAnswerRates', 'courseId', courseId);
            assertParamExists('getAllUnitsGradeCorrectAnswerRates', 'grade', grade);
            assertParamExists('getAllUnitsGradeCorrectAnswerRates', 'correctAnswerRateType', correctAnswerRateType);
            const localVarPath = `/drillweb/learning-history/grade-correct-answer-avg-rate/courses/{courseId}/units`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            if (grade !== undefined) {
                localVarQueryParameter['grade'] = grade;
            }
            if (correctAnswerRateType !== undefined) {
                localVarQueryParameter['correctAnswerRateType'] = correctAnswerRateType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getUnitCorrectAnswerRateDetail: (drillType, courseId, unitId, organizationId, correctAnswerRateType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getUnitCorrectAnswerRateDetail', 'drillType', drillType);
            assertParamExists('getUnitCorrectAnswerRateDetail', 'courseId', courseId);
            assertParamExists('getUnitCorrectAnswerRateDetail', 'unitId', unitId);
            assertParamExists('getUnitCorrectAnswerRateDetail', 'organizationId', organizationId);
            assertParamExists('getUnitCorrectAnswerRateDetail', 'correctAnswerRateType', correctAnswerRateType);
            const localVarPath = `/drillweb/learning-history/correct-answer-rate/courses/{courseId}/units/{unitId}/subunits`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)))
                .replace(`{${"unitId"}}`, encodeURIComponent(String(unitId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (correctAnswerRateType !== undefined) {
                localVarQueryParameter['correctAnswerRateType'] = correctAnswerRateType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getUnitGradeCorrectAnswerRateDetail: (drillType, courseId, unitId, grade, correctAnswerRateType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getUnitGradeCorrectAnswerRateDetail', 'drillType', drillType);
            assertParamExists('getUnitGradeCorrectAnswerRateDetail', 'courseId', courseId);
            assertParamExists('getUnitGradeCorrectAnswerRateDetail', 'unitId', unitId);
            assertParamExists('getUnitGradeCorrectAnswerRateDetail', 'grade', grade);
            assertParamExists('getUnitGradeCorrectAnswerRateDetail', 'correctAnswerRateType', correctAnswerRateType);
            const localVarPath = `/drillweb/learning-history/grade-correct-answer-avg-rate/courses/{courseId}/units/{unitId}/subunits`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)))
                .replace(`{${"unitId"}}`, encodeURIComponent(String(unitId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            if (grade !== undefined) {
                localVarQueryParameter['grade'] = grade;
            }
            if (correctAnswerRateType !== undefined) {
                localVarQueryParameter['correctAnswerRateType'] = correctAnswerRateType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const LearningHistoryControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = LearningHistoryControllerApiAxiosParamCreator(configuration);
    return {
        getAllUnitCorrectAnswerRates(drillType, courseId, organizationId, correctAnswerRateType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllUnitCorrectAnswerRates(drillType, courseId, organizationId, correctAnswerRateType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getAllUnitsGradeCorrectAnswerRates(drillType, courseId, grade, correctAnswerRateType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllUnitsGradeCorrectAnswerRates(drillType, courseId, grade, correctAnswerRateType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getUnitCorrectAnswerRateDetail(drillType, courseId, unitId, organizationId, correctAnswerRateType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUnitCorrectAnswerRateDetail(drillType, courseId, unitId, organizationId, correctAnswerRateType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getUnitGradeCorrectAnswerRateDetail(drillType, courseId, unitId, grade, correctAnswerRateType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUnitGradeCorrectAnswerRateDetail(drillType, courseId, unitId, grade, correctAnswerRateType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const LearningHistoryControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LearningHistoryControllerApiFp(configuration);
    return {
        getAllUnitCorrectAnswerRates(drillType, courseId, organizationId, correctAnswerRateType, options) {
            return localVarFp.getAllUnitCorrectAnswerRates(drillType, courseId, organizationId, correctAnswerRateType, options).then((request) => request(axios, basePath));
        },
        getAllUnitsGradeCorrectAnswerRates(drillType, courseId, grade, correctAnswerRateType, options) {
            return localVarFp.getAllUnitsGradeCorrectAnswerRates(drillType, courseId, grade, correctAnswerRateType, options).then((request) => request(axios, basePath));
        },
        getUnitCorrectAnswerRateDetail(drillType, courseId, unitId, organizationId, correctAnswerRateType, options) {
            return localVarFp.getUnitCorrectAnswerRateDetail(drillType, courseId, unitId, organizationId, correctAnswerRateType, options).then((request) => request(axios, basePath));
        },
        getUnitGradeCorrectAnswerRateDetail(drillType, courseId, unitId, grade, correctAnswerRateType, options) {
            return localVarFp.getUnitGradeCorrectAnswerRateDetail(drillType, courseId, unitId, grade, correctAnswerRateType, options).then((request) => request(axios, basePath));
        },
    };
};
export class LearningHistoryControllerApi extends BaseAPI {
    getAllUnitCorrectAnswerRates(drillType, courseId, organizationId, correctAnswerRateType, options) {
        return LearningHistoryControllerApiFp(this.configuration).getAllUnitCorrectAnswerRates(drillType, courseId, organizationId, correctAnswerRateType, options).then((request) => request(this.axios, this.basePath));
    }
    getAllUnitsGradeCorrectAnswerRates(drillType, courseId, grade, correctAnswerRateType, options) {
        return LearningHistoryControllerApiFp(this.configuration).getAllUnitsGradeCorrectAnswerRates(drillType, courseId, grade, correctAnswerRateType, options).then((request) => request(this.axios, this.basePath));
    }
    getUnitCorrectAnswerRateDetail(drillType, courseId, unitId, organizationId, correctAnswerRateType, options) {
        return LearningHistoryControllerApiFp(this.configuration).getUnitCorrectAnswerRateDetail(drillType, courseId, unitId, organizationId, correctAnswerRateType, options).then((request) => request(this.axios, this.basePath));
    }
    getUnitGradeCorrectAnswerRateDetail(drillType, courseId, unitId, grade, correctAnswerRateType, options) {
        return LearningHistoryControllerApiFp(this.configuration).getUnitGradeCorrectAnswerRateDetail(drillType, courseId, unitId, grade, correctAnswerRateType, options).then((request) => request(this.axios, this.basePath));
    }
}
export const LevelupDrillControllerApiAxiosParamCreator = function (configuration) {
    return {
        getLevelupDrillEffortStatus: (userIds, courseId, unitIds, drillType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getLevelupDrillEffortStatus', 'userIds', userIds);
            assertParamExists('getLevelupDrillEffortStatus', 'courseId', courseId);
            assertParamExists('getLevelupDrillEffortStatus', 'unitIds', unitIds);
            assertParamExists('getLevelupDrillEffortStatus', 'drillType', drillType);
            const localVarPath = `/drillweb/levelup/level`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userIds) {
                localVarQueryParameter['userIds'] = userIds;
            }
            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }
            if (unitIds) {
                localVarQueryParameter['unitIds'] = unitIds;
            }
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getLevelupDrillMyEffortStatus: (courseId, unitIds, drillType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getLevelupDrillMyEffortStatus', 'courseId', courseId);
            assertParamExists('getLevelupDrillMyEffortStatus', 'unitIds', unitIds);
            assertParamExists('getLevelupDrillMyEffortStatus', 'drillType', drillType);
            const localVarPath = `/drillweb/levelup/level/self`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }
            if (unitIds) {
                localVarQueryParameter['unitIds'] = unitIds;
            }
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getMyQuestions: (drillType, unitId, questionCount, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getMyQuestions', 'drillType', drillType);
            assertParamExists('getMyQuestions', 'unitId', unitId);
            assertParamExists('getMyQuestions', 'questionCount', questionCount);
            const localVarPath = `/drillweb/levelup/questions/self`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }
            if (questionCount !== undefined) {
                localVarQueryParameter['questionCount'] = questionCount;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const LevelupDrillControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = LevelupDrillControllerApiAxiosParamCreator(configuration);
    return {
        getLevelupDrillEffortStatus(userIds, courseId, unitIds, drillType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLevelupDrillEffortStatus(userIds, courseId, unitIds, drillType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getLevelupDrillMyEffortStatus(courseId, unitIds, drillType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLevelupDrillMyEffortStatus(courseId, unitIds, drillType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getMyQuestions(drillType, unitId, questionCount, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMyQuestions(drillType, unitId, questionCount, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const LevelupDrillControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LevelupDrillControllerApiFp(configuration);
    return {
        getLevelupDrillEffortStatus(userIds, courseId, unitIds, drillType, options) {
            return localVarFp.getLevelupDrillEffortStatus(userIds, courseId, unitIds, drillType, options).then((request) => request(axios, basePath));
        },
        getLevelupDrillMyEffortStatus(courseId, unitIds, drillType, options) {
            return localVarFp.getLevelupDrillMyEffortStatus(courseId, unitIds, drillType, options).then((request) => request(axios, basePath));
        },
        getMyQuestions(drillType, unitId, questionCount, options) {
            return localVarFp.getMyQuestions(drillType, unitId, questionCount, options).then((request) => request(axios, basePath));
        },
    };
};
export class LevelupDrillControllerApi extends BaseAPI {
    getLevelupDrillEffortStatus(userIds, courseId, unitIds, drillType, options) {
        return LevelupDrillControllerApiFp(this.configuration).getLevelupDrillEffortStatus(userIds, courseId, unitIds, drillType, options).then((request) => request(this.axios, this.basePath));
    }
    getLevelupDrillMyEffortStatus(courseId, unitIds, drillType, options) {
        return LevelupDrillControllerApiFp(this.configuration).getLevelupDrillMyEffortStatus(courseId, unitIds, drillType, options).then((request) => request(this.axios, this.basePath));
    }
    getMyQuestions(drillType, unitId, questionCount, options) {
        return LevelupDrillControllerApiFp(this.configuration).getMyQuestions(drillType, unitId, questionCount, options).then((request) => request(this.axios, this.basePath));
    }
}
export const LevelupDrillHistoryControllerApiAxiosParamCreator = function (configuration) {
    return {
        addLevelupDrillHistory: (addLevelupDrillHistoryRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('addLevelupDrillHistory', 'addLevelupDrillHistoryRequest', addLevelupDrillHistoryRequest);
            const localVarPath = `/drillweb/levelupDrillHistory`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addLevelupDrillHistoryRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getLevelupDrillHistories: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getLevelupDrillHistories', 'ids', ids);
            const localVarPath = `/drillweb/levelupDrillHistory/{ids}`
                .replace(`{${"ids"}}`, encodeURIComponent(String(ids)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updatePhase1: (levelupDrillHistoryId, updateLevelupDrillHistoryPhaseRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('updatePhase1', 'levelupDrillHistoryId', levelupDrillHistoryId);
            assertParamExists('updatePhase1', 'updateLevelupDrillHistoryPhaseRequest', updateLevelupDrillHistoryPhaseRequest);
            const localVarPath = `/drillweb/levelupDrillHistory/{levelupDrillHistoryId}`
                .replace(`{${"levelupDrillHistoryId"}}`, encodeURIComponent(String(levelupDrillHistoryId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateLevelupDrillHistoryPhaseRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const LevelupDrillHistoryControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = LevelupDrillHistoryControllerApiAxiosParamCreator(configuration);
    return {
        addLevelupDrillHistory(addLevelupDrillHistoryRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addLevelupDrillHistory(addLevelupDrillHistoryRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getLevelupDrillHistories(ids, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLevelupDrillHistories(ids, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        updatePhase1(levelupDrillHistoryId, updateLevelupDrillHistoryPhaseRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePhase1(levelupDrillHistoryId, updateLevelupDrillHistoryPhaseRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const LevelupDrillHistoryControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LevelupDrillHistoryControllerApiFp(configuration);
    return {
        addLevelupDrillHistory(addLevelupDrillHistoryRequest, options) {
            return localVarFp.addLevelupDrillHistory(addLevelupDrillHistoryRequest, options).then((request) => request(axios, basePath));
        },
        getLevelupDrillHistories(ids, options) {
            return localVarFp.getLevelupDrillHistories(ids, options).then((request) => request(axios, basePath));
        },
        updatePhase1(levelupDrillHistoryId, updateLevelupDrillHistoryPhaseRequest, options) {
            return localVarFp.updatePhase1(levelupDrillHistoryId, updateLevelupDrillHistoryPhaseRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class LevelupDrillHistoryControllerApi extends BaseAPI {
    addLevelupDrillHistory(addLevelupDrillHistoryRequest, options) {
        return LevelupDrillHistoryControllerApiFp(this.configuration).addLevelupDrillHistory(addLevelupDrillHistoryRequest, options).then((request) => request(this.axios, this.basePath));
    }
    getLevelupDrillHistories(ids, options) {
        return LevelupDrillHistoryControllerApiFp(this.configuration).getLevelupDrillHistories(ids, options).then((request) => request(this.axios, this.basePath));
    }
    updatePhase1(levelupDrillHistoryId, updateLevelupDrillHistoryPhaseRequest, options) {
        return LevelupDrillHistoryControllerApiFp(this.configuration).updatePhase1(levelupDrillHistoryId, updateLevelupDrillHistoryPhaseRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
export const LevelupDrillQuestionHistoryDetailControllerApiAxiosParamCreator = function (configuration) {
    return {
        addLevelupDrillQuestionHistoryDetail: (levelupDrillHistoryId, updateLevelupDrillQuestionHistoryDetailsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('addLevelupDrillQuestionHistoryDetail', 'levelupDrillHistoryId', levelupDrillHistoryId);
            assertParamExists('addLevelupDrillQuestionHistoryDetail', 'updateLevelupDrillQuestionHistoryDetailsRequest', updateLevelupDrillQuestionHistoryDetailsRequest);
            const localVarPath = `/drillweb/levelupDrillHistory/{levelupDrillHistoryId}/questionHistory`
                .replace(`{${"levelupDrillHistoryId"}}`, encodeURIComponent(String(levelupDrillHistoryId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateLevelupDrillQuestionHistoryDetailsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        addLevelupDrillQuestionHistoryDetail1: (levelupDrillHistoryId, addLevelupDrillQuestionHistoryDetailsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('addLevelupDrillQuestionHistoryDetail1', 'levelupDrillHistoryId', levelupDrillHistoryId);
            assertParamExists('addLevelupDrillQuestionHistoryDetail1', 'addLevelupDrillQuestionHistoryDetailsRequest', addLevelupDrillQuestionHistoryDetailsRequest);
            const localVarPath = `/drillweb/levelupDrillHistory/{levelupDrillHistoryId}/questionHistory`
                .replace(`{${"levelupDrillHistoryId"}}`, encodeURIComponent(String(levelupDrillHistoryId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addLevelupDrillQuestionHistoryDetailsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const LevelupDrillQuestionHistoryDetailControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = LevelupDrillQuestionHistoryDetailControllerApiAxiosParamCreator(configuration);
    return {
        addLevelupDrillQuestionHistoryDetail(levelupDrillHistoryId, updateLevelupDrillQuestionHistoryDetailsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addLevelupDrillQuestionHistoryDetail(levelupDrillHistoryId, updateLevelupDrillQuestionHistoryDetailsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        addLevelupDrillQuestionHistoryDetail1(levelupDrillHistoryId, addLevelupDrillQuestionHistoryDetailsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addLevelupDrillQuestionHistoryDetail1(levelupDrillHistoryId, addLevelupDrillQuestionHistoryDetailsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const LevelupDrillQuestionHistoryDetailControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LevelupDrillQuestionHistoryDetailControllerApiFp(configuration);
    return {
        addLevelupDrillQuestionHistoryDetail(levelupDrillHistoryId, updateLevelupDrillQuestionHistoryDetailsRequest, options) {
            return localVarFp.addLevelupDrillQuestionHistoryDetail(levelupDrillHistoryId, updateLevelupDrillQuestionHistoryDetailsRequest, options).then((request) => request(axios, basePath));
        },
        addLevelupDrillQuestionHistoryDetail1(levelupDrillHistoryId, addLevelupDrillQuestionHistoryDetailsRequest, options) {
            return localVarFp.addLevelupDrillQuestionHistoryDetail1(levelupDrillHistoryId, addLevelupDrillQuestionHistoryDetailsRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class LevelupDrillQuestionHistoryDetailControllerApi extends BaseAPI {
    addLevelupDrillQuestionHistoryDetail(levelupDrillHistoryId, updateLevelupDrillQuestionHistoryDetailsRequest, options) {
        return LevelupDrillQuestionHistoryDetailControllerApiFp(this.configuration).addLevelupDrillQuestionHistoryDetail(levelupDrillHistoryId, updateLevelupDrillQuestionHistoryDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    addLevelupDrillQuestionHistoryDetail1(levelupDrillHistoryId, addLevelupDrillQuestionHistoryDetailsRequest, options) {
        return LevelupDrillQuestionHistoryDetailControllerApiFp(this.configuration).addLevelupDrillQuestionHistoryDetail1(levelupDrillHistoryId, addLevelupDrillQuestionHistoryDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
export const LevelupDrillRecommendControllerApiAxiosParamCreator = function (configuration) {
    return {
        addTeacherRecommend: (addTeacherRecommendRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('addTeacherRecommend', 'addTeacherRecommendRequest', addTeacherRecommendRequest);
            const localVarPath = `/drillweb/levelup/recommend/teacher`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addTeacherRecommendRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        deleteTeacherRecommend: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('deleteTeacherRecommend', 'id', id);
            const localVarPath = `/drillweb/levelup/recommend/teacher/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getRecommends: (userIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getRecommends', 'userIds', userIds);
            const localVarPath = `/drillweb/levelup/recommend`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userIds) {
                localVarQueryParameter['userIds'] = userIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getRecommendsStreaming: (userIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getRecommendsStreaming', 'userIds', userIds);
            const localVarPath = `/drillweb/levelup/recommend/streaming`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (userIds) {
                localVarQueryParameter['userIds'] = userIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getSelf: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/drillweb/levelup/recommend/self`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getTeacherRecommendHistory: (drillType, userIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getTeacherRecommendHistory', 'drillType', drillType);
            assertParamExists('getTeacherRecommendHistory', 'userIds', userIds);
            const localVarPath = `/drillweb/levelup/recommend/teacher/history`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            if (userIds) {
                localVarQueryParameter['userIds'] = userIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const LevelupDrillRecommendControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = LevelupDrillRecommendControllerApiAxiosParamCreator(configuration);
    return {
        addTeacherRecommend(addTeacherRecommendRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addTeacherRecommend(addTeacherRecommendRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        deleteTeacherRecommend(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteTeacherRecommend(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getRecommends(userIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRecommends(userIds, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getRecommendsStreaming(userIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRecommendsStreaming(userIds, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getSelf(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSelf(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getTeacherRecommendHistory(drillType, userIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTeacherRecommendHistory(drillType, userIds, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const LevelupDrillRecommendControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LevelupDrillRecommendControllerApiFp(configuration);
    return {
        addTeacherRecommend(addTeacherRecommendRequest, options) {
            return localVarFp.addTeacherRecommend(addTeacherRecommendRequest, options).then((request) => request(axios, basePath));
        },
        deleteTeacherRecommend(id, options) {
            return localVarFp.deleteTeacherRecommend(id, options).then((request) => request(axios, basePath));
        },
        getRecommends(userIds, options) {
            return localVarFp.getRecommends(userIds, options).then((request) => request(axios, basePath));
        },
        getRecommendsStreaming(userIds, options) {
            return localVarFp.getRecommendsStreaming(userIds, options).then((request) => request(axios, basePath));
        },
        getSelf(options) {
            return localVarFp.getSelf(options).then((request) => request(axios, basePath));
        },
        getTeacherRecommendHistory(drillType, userIds, options) {
            return localVarFp.getTeacherRecommendHistory(drillType, userIds, options).then((request) => request(axios, basePath));
        },
    };
};
export class LevelupDrillRecommendControllerApi extends BaseAPI {
    addTeacherRecommend(addTeacherRecommendRequest, options) {
        return LevelupDrillRecommendControllerApiFp(this.configuration).addTeacherRecommend(addTeacherRecommendRequest, options).then((request) => request(this.axios, this.basePath));
    }
    deleteTeacherRecommend(id, options) {
        return LevelupDrillRecommendControllerApiFp(this.configuration).deleteTeacherRecommend(id, options).then((request) => request(this.axios, this.basePath));
    }
    getRecommends(userIds, options) {
        return LevelupDrillRecommendControllerApiFp(this.configuration).getRecommends(userIds, options).then((request) => request(this.axios, this.basePath));
    }
    getRecommendsStreaming(userIds, options) {
        return LevelupDrillRecommendControllerApiFp(this.configuration).getRecommendsStreaming(userIds, options).then((request) => request(this.axios, this.basePath));
    }
    getSelf(options) {
        return LevelupDrillRecommendControllerApiFp(this.configuration).getSelf(options).then((request) => request(this.axios, this.basePath));
    }
    getTeacherRecommendHistory(drillType, userIds, options) {
        return LevelupDrillRecommendControllerApiFp(this.configuration).getTeacherRecommendHistory(drillType, userIds, options).then((request) => request(this.axios, this.basePath));
    }
}
export const QuestionControllerApiAxiosParamCreator = function (configuration) {
    return {
        getAutoSelectedQuestionList: (drillType, unitId, subunitIds, kinds, estimatedWorkingTime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getAutoSelectedQuestionList', 'drillType', drillType);
            assertParamExists('getAutoSelectedQuestionList', 'unitId', unitId);
            const localVarPath = `/drillweb/work/autoSelectQuestion`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }
            if (subunitIds) {
                localVarQueryParameter['subunitIds'] = subunitIds;
            }
            if (kinds) {
                localVarQueryParameter['kinds'] = kinds;
            }
            if (estimatedWorkingTime !== undefined) {
                localVarQueryParameter['estimatedWorkingTime'] = estimatedWorkingTime;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const QuestionControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = QuestionControllerApiAxiosParamCreator(configuration);
    return {
        getAutoSelectedQuestionList(drillType, unitId, subunitIds, kinds, estimatedWorkingTime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAutoSelectedQuestionList(drillType, unitId, subunitIds, kinds, estimatedWorkingTime, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const QuestionControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = QuestionControllerApiFp(configuration);
    return {
        getAutoSelectedQuestionList(drillType, unitId, subunitIds, kinds, estimatedWorkingTime, options) {
            return localVarFp.getAutoSelectedQuestionList(drillType, unitId, subunitIds, kinds, estimatedWorkingTime, options).then((request) => request(axios, basePath));
        },
    };
};
export class QuestionControllerApi extends BaseAPI {
    getAutoSelectedQuestionList(drillType, unitId, subunitIds, kinds, estimatedWorkingTime, options) {
        return QuestionControllerApiFp(this.configuration).getAutoSelectedQuestionList(drillType, unitId, subunitIds, kinds, estimatedWorkingTime, options).then((request) => request(this.axios, this.basePath));
    }
}
export const WorkAnswerHistoryControllerApiAxiosParamCreator = function (configuration) {
    return {
        getAnswerByOriginWorkId: (originWorkId, userId, onlyFirst, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getAnswerByOriginWorkId', 'originWorkId', originWorkId);
            assertParamExists('getAnswerByOriginWorkId', 'userId', userId);
            assertParamExists('getAnswerByOriginWorkId', 'onlyFirst', onlyFirst);
            const localVarPath = `/drillweb/workHistory/answer`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (originWorkId !== undefined) {
                localVarQueryParameter['originWorkId'] = originWorkId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (onlyFirst !== undefined) {
                localVarQueryParameter['onlyFirst'] = onlyFirst;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const WorkAnswerHistoryControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkAnswerHistoryControllerApiAxiosParamCreator(configuration);
    return {
        getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const WorkAnswerHistoryControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkAnswerHistoryControllerApiFp(configuration);
    return {
        getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options) {
            return localVarFp.getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options).then((request) => request(axios, basePath));
        },
    };
};
export class WorkAnswerHistoryControllerApi extends BaseAPI {
    getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options) {
        return WorkAnswerHistoryControllerApiFp(this.configuration).getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options).then((request) => request(this.axios, this.basePath));
    }
}
export const WorkControllerApiAxiosParamCreator = function (configuration) {
    return {
        addWork: (addWorkRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('addWork', 'addWorkRequest', addWorkRequest);
            const localVarPath = `/drillweb/works`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addWorkRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        cloneWork: (cloneWorkRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('cloneWork', 'cloneWorkRequest', cloneWorkRequest);
            const localVarPath = `/drillweb/works/clone`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cloneWorkRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        deleteWork: (workId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('deleteWork', 'workId', workId);
            const localVarPath = `/drillweb/works/{workId}`
                .replace(`{${"workId"}}`, encodeURIComponent(String(workId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getWorkById: (workId, checkWork, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getWorkById', 'workId', workId);
            const localVarPath = `/drillweb/works/{workId}`
                .replace(`{${"workId"}}`, encodeURIComponent(String(workId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (checkWork !== undefined) {
                localVarQueryParameter['checkWork'] = checkWork;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getWorkList: (fileSort, order, size, page, workType, targetUserId, name, afterCreatedDateTime, untilCreatedDateTime, drillType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getWorkList', 'fileSort', fileSort);
            assertParamExists('getWorkList', 'order', order);
            assertParamExists('getWorkList', 'size', size);
            assertParamExists('getWorkList', 'page', page);
            const localVarPath = `/drillweb/works`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (workType !== undefined) {
                localVarQueryParameter['workType'] = workType;
            }
            if (targetUserId !== undefined) {
                localVarQueryParameter['targetUserId'] = targetUserId;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (afterCreatedDateTime !== undefined) {
                localVarQueryParameter['afterCreatedDateTime'] = afterCreatedDateTime;
            }
            if (untilCreatedDateTime !== undefined) {
                localVarQueryParameter['untilCreatedDateTime'] = untilCreatedDateTime;
            }
            if (drillType !== undefined) {
                localVarQueryParameter['drillType'] = drillType;
            }
            if (fileSort !== undefined) {
                localVarQueryParameter['fileSort'] = fileSort;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updateWork: (workId, updateWorkRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('updateWork', 'workId', workId);
            assertParamExists('updateWork', 'updateWorkRequest', updateWorkRequest);
            const localVarPath = `/drillweb/works/{workId}`
                .replace(`{${"workId"}}`, encodeURIComponent(String(workId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const WorkControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkControllerApiAxiosParamCreator(configuration);
    return {
        addWork(addWorkRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addWork(addWorkRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        cloneWork(cloneWorkRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cloneWork(cloneWorkRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        deleteWork(workId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteWork(workId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getWorkById(workId, checkWork, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkById(workId, checkWork, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getWorkList(fileSort, order, size, page, workType, targetUserId, name, afterCreatedDateTime, untilCreatedDateTime, drillType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkList(fileSort, order, size, page, workType, targetUserId, name, afterCreatedDateTime, untilCreatedDateTime, drillType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        updateWork(workId, updateWorkRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateWork(workId, updateWorkRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const WorkControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkControllerApiFp(configuration);
    return {
        addWork(addWorkRequest, options) {
            return localVarFp.addWork(addWorkRequest, options).then((request) => request(axios, basePath));
        },
        cloneWork(cloneWorkRequest, options) {
            return localVarFp.cloneWork(cloneWorkRequest, options).then((request) => request(axios, basePath));
        },
        deleteWork(workId, options) {
            return localVarFp.deleteWork(workId, options).then((request) => request(axios, basePath));
        },
        getWorkById(workId, checkWork, options) {
            return localVarFp.getWorkById(workId, checkWork, options).then((request) => request(axios, basePath));
        },
        getWorkList(fileSort, order, size, page, workType, targetUserId, name, afterCreatedDateTime, untilCreatedDateTime, drillType, options) {
            return localVarFp.getWorkList(fileSort, order, size, page, workType, targetUserId, name, afterCreatedDateTime, untilCreatedDateTime, drillType, options).then((request) => request(axios, basePath));
        },
        updateWork(workId, updateWorkRequest, options) {
            return localVarFp.updateWork(workId, updateWorkRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class WorkControllerApi extends BaseAPI {
    addWork(addWorkRequest, options) {
        return WorkControllerApiFp(this.configuration).addWork(addWorkRequest, options).then((request) => request(this.axios, this.basePath));
    }
    cloneWork(cloneWorkRequest, options) {
        return WorkControllerApiFp(this.configuration).cloneWork(cloneWorkRequest, options).then((request) => request(this.axios, this.basePath));
    }
    deleteWork(workId, options) {
        return WorkControllerApiFp(this.configuration).deleteWork(workId, options).then((request) => request(this.axios, this.basePath));
    }
    getWorkById(workId, checkWork, options) {
        return WorkControllerApiFp(this.configuration).getWorkById(workId, checkWork, options).then((request) => request(this.axios, this.basePath));
    }
    getWorkList(fileSort, order, size, page, workType, targetUserId, name, afterCreatedDateTime, untilCreatedDateTime, drillType, options) {
        return WorkControllerApiFp(this.configuration).getWorkList(fileSort, order, size, page, workType, targetUserId, name, afterCreatedDateTime, untilCreatedDateTime, drillType, options).then((request) => request(this.axios, this.basePath));
    }
    updateWork(workId, updateWorkRequest, options) {
        return WorkControllerApiFp(this.configuration).updateWork(workId, updateWorkRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
export const WorkHistoryControllerApiAxiosParamCreator = function (configuration) {
    return {
        addWorkHistory: (addWorkHistoryRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('addWorkHistory', 'addWorkHistoryRequest', addWorkHistoryRequest);
            const localVarPath = `/drillweb/workHistory`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addWorkHistoryRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getAnswerByOriginWorkId: (originWorkId, userId, onlyFirst, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getAnswerByOriginWorkId', 'originWorkId', originWorkId);
            assertParamExists('getAnswerByOriginWorkId', 'userId', userId);
            assertParamExists('getAnswerByOriginWorkId', 'onlyFirst', onlyFirst);
            const localVarPath = `/drillweb/workHistory/answer`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (originWorkId !== undefined) {
                localVarQueryParameter['originWorkId'] = originWorkId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (onlyFirst !== undefined) {
                localVarQueryParameter['onlyFirst'] = onlyFirst;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getWorkHistories: (ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getWorkHistories', 'ids', ids);
            const localVarPath = `/drillweb/workHistory/{ids}`
                .replace(`{${"ids"}}`, encodeURIComponent(String(ids)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        resume: (workId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('resume', 'workId', workId);
            const localVarPath = `/drillweb/workHistory/resume`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (workId !== undefined) {
                localVarQueryParameter['workId'] = workId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        updatePhase: (workHistoryId, updateWorkHistoryPhaseRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('updatePhase', 'workHistoryId', workHistoryId);
            assertParamExists('updatePhase', 'updateWorkHistoryPhaseRequest', updateWorkHistoryPhaseRequest);
            const localVarPath = `/drillweb/workHistory/{workHistoryId}`
                .replace(`{${"workHistoryId"}}`, encodeURIComponent(String(workHistoryId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkHistoryPhaseRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const WorkHistoryControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkHistoryControllerApiAxiosParamCreator(configuration);
    return {
        addWorkHistory(addWorkHistoryRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addWorkHistory(addWorkHistoryRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getWorkHistories(ids, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkHistories(ids, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        resume(workId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resume(workId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        updatePhase(workHistoryId, updateWorkHistoryPhaseRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePhase(workHistoryId, updateWorkHistoryPhaseRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const WorkHistoryControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkHistoryControllerApiFp(configuration);
    return {
        addWorkHistory(addWorkHistoryRequest, options) {
            return localVarFp.addWorkHistory(addWorkHistoryRequest, options).then((request) => request(axios, basePath));
        },
        getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options) {
            return localVarFp.getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options).then((request) => request(axios, basePath));
        },
        getWorkHistories(ids, options) {
            return localVarFp.getWorkHistories(ids, options).then((request) => request(axios, basePath));
        },
        resume(workId, options) {
            return localVarFp.resume(workId, options).then((request) => request(axios, basePath));
        },
        updatePhase(workHistoryId, updateWorkHistoryPhaseRequest, options) {
            return localVarFp.updatePhase(workHistoryId, updateWorkHistoryPhaseRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class WorkHistoryControllerApi extends BaseAPI {
    addWorkHistory(addWorkHistoryRequest, options) {
        return WorkHistoryControllerApiFp(this.configuration).addWorkHistory(addWorkHistoryRequest, options).then((request) => request(this.axios, this.basePath));
    }
    getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options) {
        return WorkHistoryControllerApiFp(this.configuration).getAnswerByOriginWorkId(originWorkId, userId, onlyFirst, options).then((request) => request(this.axios, this.basePath));
    }
    getWorkHistories(ids, options) {
        return WorkHistoryControllerApiFp(this.configuration).getWorkHistories(ids, options).then((request) => request(this.axios, this.basePath));
    }
    resume(workId, options) {
        return WorkHistoryControllerApiFp(this.configuration).resume(workId, options).then((request) => request(this.axios, this.basePath));
    }
    updatePhase(workHistoryId, updateWorkHistoryPhaseRequest, options) {
        return WorkHistoryControllerApiFp(this.configuration).updatePhase(workHistoryId, updateWorkHistoryPhaseRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
export const WorkQuestionHistoryDetailControllerApiAxiosParamCreator = function (configuration) {
    return {
        addWorkQuestionHistoryDetail: (workHistoryId, updateWorkQuestionHistoryDetailsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('addWorkQuestionHistoryDetail', 'workHistoryId', workHistoryId);
            assertParamExists('addWorkQuestionHistoryDetail', 'updateWorkQuestionHistoryDetailsRequest', updateWorkQuestionHistoryDetailsRequest);
            const localVarPath = `/drillweb/workHistory/{workHistoryId}/questionHistory`
                .replace(`{${"workHistoryId"}}`, encodeURIComponent(String(workHistoryId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkQuestionHistoryDetailsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        addWorkQuestionHistoryDetail1: (workHistoryId, addWorkQuestionHistoryDetailsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('addWorkQuestionHistoryDetail1', 'workHistoryId', workHistoryId);
            assertParamExists('addWorkQuestionHistoryDetail1', 'addWorkQuestionHistoryDetailsRequest', addWorkQuestionHistoryDetailsRequest);
            const localVarPath = `/drillweb/workHistory/{workHistoryId}/questionHistory`
                .replace(`{${"workHistoryId"}}`, encodeURIComponent(String(workHistoryId)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addWorkQuestionHistoryDetailsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const WorkQuestionHistoryDetailControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkQuestionHistoryDetailControllerApiAxiosParamCreator(configuration);
    return {
        addWorkQuestionHistoryDetail(workHistoryId, updateWorkQuestionHistoryDetailsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addWorkQuestionHistoryDetail(workHistoryId, updateWorkQuestionHistoryDetailsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        addWorkQuestionHistoryDetail1(workHistoryId, addWorkQuestionHistoryDetailsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addWorkQuestionHistoryDetail1(workHistoryId, addWorkQuestionHistoryDetailsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const WorkQuestionHistoryDetailControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkQuestionHistoryDetailControllerApiFp(configuration);
    return {
        addWorkQuestionHistoryDetail(workHistoryId, updateWorkQuestionHistoryDetailsRequest, options) {
            return localVarFp.addWorkQuestionHistoryDetail(workHistoryId, updateWorkQuestionHistoryDetailsRequest, options).then((request) => request(axios, basePath));
        },
        addWorkQuestionHistoryDetail1(workHistoryId, addWorkQuestionHistoryDetailsRequest, options) {
            return localVarFp.addWorkQuestionHistoryDetail1(workHistoryId, addWorkQuestionHistoryDetailsRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class WorkQuestionHistoryDetailControllerApi extends BaseAPI {
    addWorkQuestionHistoryDetail(workHistoryId, updateWorkQuestionHistoryDetailsRequest, options) {
        return WorkQuestionHistoryDetailControllerApiFp(this.configuration).addWorkQuestionHistoryDetail(workHistoryId, updateWorkQuestionHistoryDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    addWorkQuestionHistoryDetail1(workHistoryId, addWorkQuestionHistoryDetailsRequest, options) {
        return WorkQuestionHistoryDetailControllerApiFp(this.configuration).addWorkQuestionHistoryDetail1(workHistoryId, addWorkQuestionHistoryDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map